import PropTypes from 'prop-types';

const favoritesServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  addFavourites: PropTypes.func,
  getFavouriteActivityList: PropTypes.func,
  removeFavorites: PropTypes.func,
});

export default favoritesServiceShape;
